import { useMemo } from "react";
import {
    createCounterpartyDirectoryViewConfig,
    createDefaultCounterpartyDirectoryView,
} from "./counterpartyDirectoryViewConfig";

export function useCounterpartyDirectoryViewConfig() {
    const viewConfig = useMemo(
        () => createCounterpartyDirectoryViewConfig(),
        [],
    );

    const defaultView = useMemo(
        () => createDefaultCounterpartyDirectoryView(),
        [],
    );

    return { viewConfig, defaultView };
}
